import { Tab as HeadlessTab } from '@coveo/headless';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useCurrentVideoStore } from 'src/helpers/VideoGalleryHelpers/VideoListing.store';

type CoveoTabProps = PropsWithChildren<React.ReactNode | React.ReactNode[]> & {
  controller: HeadlessTab;
  classes: {
    tabButton: string;
  };
  onSelected?: () => void;
  selectOnFocus?: boolean;
};

export const CoveoTab = React.forwardRef<HTMLButtonElement, CoveoTabProps>((props, ref) => {
  const { controller, classes, selectOnFocus } = props;
  const [state, setState] = useState(controller.state);
  const { setTabClicked } = useCurrentVideoStore();

  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  const handleSelect = () => {
    if (state.isActive) {
      return;
    }
    setTabClicked(true);
    props.onSelected?.();
    controller.select();
  };

  return (
    <button
      ref={ref}
      className={classes.tabButton}
      disabled={state.isActive}
      onClick={handleSelect}
      onFocus={() => {
        if (!selectOnFocus) {
          return;
        }
        handleSelect();
      }}
    >
      {props.children}
    </button>
  );
});
CoveoTab.displayName = 'CoveoTab';
